import { pagesPath } from "faqSrc/lib/$path";
import Link from "next/link";
import React, { VFC } from "react";
import styled, { css } from "styled-components";
import Image from "components/atoms/Image";
import { breakPoint } from "~/lib/constants";
import { convertToLinkHref, externalLinkAttrs } from "~/lib/utils/urlHelper";
import { User } from "~/models/user";

interface Props {
  isForceSP?: boolean;
  host?: string;
  user: User;
}

const UserIconAndName: VFC<Props> = ({ isForceSP, host, user }) => {
  if (!user.id) {
    return <></>;
  }

  const userUrl = convertToLinkHref({
    host,
    url: pagesPath.creators._id(user.id).$url(),
  });
  const nameLen = Buffer.from(user.name).length;

  return (
    <Link href={userUrl} passHref>
      <UserInfo {...externalLinkAttrs(userUrl)}>
        <ImageWrap>
          {user.imageUrl && (
            <Image
              alt={user.name}
              ampLayout="responsive"
              height={48}
              layout="responsive"
              src={user.imageUrl}
              width={48}
              unLazyLoad
            />
          )}
        </ImageWrap>
        <UserName className="limited-line--1" isForceSP={isForceSP}>
          <span className="base-name">{nameLen > 6 ? "筆者" : user.name}</span>
          <span className="short-name">{nameLen > 5 ? "筆者" : user.name}</span>
        </UserName>
      </UserInfo>
    </Link>
  );
};

const ImageWrap = styled.div`
  border-radius: 50%;
  display: block;
  height: auto;
  margin: auto;
  overflow: hidden;
  width: 48px;
  max-width: 100%;
`;

const UserName = styled.div<{ isForceSP?: boolean }>`
  color: var(--b-clr300);
  font-size: 12px;
  text-align: center;
  text-decoration: none;
  > .short-name {
    display: none;
  }

  @media only screen and (max-width: ${breakPoint["sm"]}) {
    font-size: 11px;
    > .base-name {
      display: none;
    }
    > .short-name {
      display: inline;
    }
  }

  ${({ isForceSP }) => {
    if (isForceSP) {
      return css`
        @media only screen and (min-width: 769px) {
          font-size: 11px;
          > .base-name {
            display: none;
          }
          > .short-name {
            display: inline;
          }
        }
      `;
    }
  }};
`;

const UserInfo = styled.a`
  position: relative;
  text-decoration: none;

  &:hover {
    ${UserName} {
      text-decoration: underline;
    }
    ${ImageWrap} {
      opacity: 0.8;
    }
  }
`;

export default UserIconAndName;
